import { createActions } from "../../utils/reduxsauce";

const { Types, Creators } = createActions(
  {
    getStarterKit: { args: ["payload"], meta: { async: true } },
    getAllStarterKits: { args: ["payload"], meta: { async: true } },
    createStarterKit: { args: ["payload"], meta: { async: true } },
    editStarterKit: { args: ["payload"], meta: { async: true } },
    deleteStarterKit: { args: ["payload"], meta: { async: true } },
    showDialog: { args: [], meta: { async: false } },
    showDeleteDialog: { args: [], meta: { async: false } },
    resetDialog: { args: [], meta: { async: false } },
  },
  {
    prefix: "@app/StarterKits/",
  },
);
export const ActionTypes = Types;
export default Creators;
